export default class Brieffeld {
    public brieffeld_id: number | null = null;
    public briefart_id: number | null = null;
    public feldnummer: number | null = null;
    public bezeichnung: string | null = null;
    public vorgabe: string | null = null;

    constructor(feldnummer: number) {
        this.feldnummer = feldnummer;
    }
}
